export default __webpack_public_path__ + "static/media/Floor1MintTowerBuildingMain.a0ad3d00.svg";